export const entityBoxes = {
  namespaced: true,
  //persistent: ["department", "process", "datasource", "data"],

  state: {
    department: undefined,
    process: undefined,
  },
  getters: {
    department: (state) => state.department,
    process: (state) => state.process,
  },
  mutations: {
    clear: (state, va) => {
      state.department = undefined;
      state.process = undefined;
    },

    clearFrom: (state, value) => {
      let toBeCleared = [];
      if (value == "process") {
        toBeCleared = ["process"];
      }

      toBeCleared.forEach((i) => {
        if (state[i]) {
          state[i] = undefined;
        }
      });
    },
    department: (state, value) => {
      if (state.department == value) {
        return;
      }
      state.department = value;
      state.process = undefined;
    },
    process: (state, value) => {
      if (state.process == value) {
        return;
      }
      state.process = value;
    },
  },
  actions: {
    async selectDepartment({ getters, rootGetters, commit, dispatch }, item) {
      if (getters.department?._id == item._id) {
        commit("department", undefined);
        commit("organizationDepartment/selectedEntity", undefined, { root: true });
      } else {
        commit("department", item);
        commit("organizationDepartment/selectedEntity", item, { root: true });
      }
    },
    async selectProcess({ getters, rootGetters, commit, dispatch }, item) {
      if (getters.process?._id == item._id) {
        commit("process", undefined);
        commit("organizationDepartmentProcess/selectedEntity", undefined, { root: true });
      } else {
        commit("process", item);
        commit("organizationDepartmentProcess/selectedEntity", item, { root: true });
      }
    },
  },
};
